import React, { useState } from 'react';
import { Send, StickyNote } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';

export function WaTicketReply({ t, onDone }) {
  const [reply, setReply] = useState('');
  const [close, setClose] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const respond = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/wa-tickets/${t.id}/respond`, { message: reply, close_ticket: close });
      if (data.whatsapp_sent) toast.success(close ? 'Respuesta enviada por WhatsApp y ticket resuelto' : 'Respuesta enviada por WhatsApp');
      else toast.warning(data.error || 'Guardada en el ticket, pero no se envió por WhatsApp');
      setReply(''); setClose(false); onDone();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const saveNote = async () => {
    setBusy(true);
    try { await api.post(`/wa-tickets/${t.id}/notes`, { note }); toast.success('Nota interna guardada'); setNote(''); onDone(); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4 pt-2 border-t border-border">
      <div>
        <label className="text-sm font-medium flex items-center gap-1.5 mb-1"><Send className="w-4 h-4" />Responder por WhatsApp</label>
        {!t.window_open && <p className="text-xs text-amber-300 mb-1" data-testid="wa-ticket-window-closed">La ventana de 24 h está cerrada: la respuesta se guardará en el ticket pero no llegará por WhatsApp.</p>}
        <Textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={3} placeholder="Escribe la respuesta que recibirá por WhatsApp…" data-testid="wa-ticket-reply-input" />
        <div className="flex items-center justify-between mt-2">
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={close} onCheckedChange={(v) => setClose(!!v)} data-testid="wa-ticket-reply-close" />Marcar como resuelto
          </label>
          <Button onClick={respond} disabled={busy || !reply.trim()} data-testid="wa-ticket-reply-send"><Send className="w-4 h-4 mr-2" />Enviar</Button>
        </div>
      </div>
      <div>
        <label className="text-sm font-medium flex items-center gap-1.5 mb-1"><StickyNote className="w-4 h-4 text-amber-400" />Nota interna</label>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Visible solo para el equipo…" data-testid="wa-ticket-note-input" />
        <div className="flex justify-end mt-2">
          <Button variant="outline" onClick={saveNote} disabled={busy || !note.trim()} data-testid="wa-ticket-note-save">Guardar nota</Button>
        </div>
      </div>
    </div>
  );
}
